var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFooterWaveDesktop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1440 79"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#031E29",
  d: "M1182.5 0C1302 0 1440 41 1440 41v38H0V22S104.5 0 262.5 0s261 52 440 52 360.5-52 480-52"
})));
export default SvgFooterWaveDesktop;